import VanillaCalendar from 'vanilla-calendar-pro';
import {set} from "js-cookie";

export class MovieFilter {

    public calendar;
    private $filter;
    private defaultDates;
    private list;

    constructor(list) {
        this.list = list;
        this.$filter = document.querySelector('form.filter');
        if (!this.$filter) return;

        if (window.movieDates) {
            const locale = (window.lang == 'de') ? 'de-CH' : 'fr-CH';
            this.defaultDates = window.movieDates.map(entry => entry.date);
            this.initCalendar(locale);
        }

        //toggle filter
        this.$filter.querySelector('.filter-toggle a').addEventListener('click', e => {
            e.preventDefault();
            const active = this.$filter.querySelector('.is-active');
            if (active) {
                active.classList.remove('is-active');
            }

            this.$filter.classList.toggle('is-active');
        });

        this.$filter.addEventListener('submit', (e) => {
            e.preventDefault();
        });

        //filter submit (list.reset reloads the list with filters)
        this.$filter.querySelectorAll('input, select').forEach(input => {
            input.addEventListener('change', () => {
                list.reset();
            });
            input.addEventListener('keyup', () => {
                list.reset();
            });
        });

        //reset filter
        this.$filter.querySelector('.reset').addEventListener('click', e => {
            //reset calendar
            if (this.calendar) {
                this.calendar.selectedDates = [];
                this.setDates(this.defaultDates);
            }

            //reset default form inputs
            this.$filter.reset();
            list.reset();

            //set selected
            this.$filter.querySelectorAll('.checkbox-select').forEach($select => {
                this.setSelectedValues($select);
            });
        });

        const $selects = this.$filter.querySelectorAll('.checkbox-select, .tag-select');
        $selects.forEach($select => {
            $select.addEventListener('click', (e) => {
                if (!$select.classList.contains('is-active')) {
                    e.preventDefault();
                    $selects.forEach($s => {
                        $s.classList.remove('is-active');
                    });

                    $select.classList.add('is-active');
                } else if (e.target.classList.contains('plus') || e.target.closest('.plus') || e.target.closest('label')?.parentElement.classList.contains('checkbox-select')) {
                    $select.classList.remove('is-active');
                }
            });
        });

        this.$filter.querySelectorAll('.checkbox-select').forEach($select => {
            const $checkboxes = $select.querySelectorAll('input');
            $checkboxes.forEach($checkbox => {
                $checkbox.addEventListener('change', () => {
                    this.setSelectedValues($select)
                });
            })
        });
    }

    private setSelectedValues($select) {
        const $checkboxes = $select.querySelectorAll('input');
        let values = '';
        $checkboxes.forEach($checkbox => {
            if ($checkbox.checked) {
                values += $checkbox.nextElementSibling.innerHTML + ', ';
            }
        });

        if (values) values = '(' + values.replace(/,\s*$/, ')');

        $select.querySelector('.selected').innerHTML = values
    }

    private initCalendar(locale) {
        const self = this;
        this.calendar = new VanillaCalendar('#calendar', {
            settings: {
                lang: locale,
                range: {
                    disableAllDays: true,
                    enabled: this.defaultDates,
                },
                selection: {
                    day: 'multiple',
                },
                visibility: {
                    theme: 'light',
                    weekend: false,
                    today: false,
                },
            },
            actions: {
                clickDay() {
                    self.list.reset();
                },
            },
        });
        this.calendar.init();
    }

    public setDates(dates) {
        if (!this.calendar) return;
        this.calendar.settings.range.enabled = dates;

        this.calendar.settings.selected.month = this.calendar.selectedMonth;
        this.calendar.update({month: true});
    }

    public getValues() {
        const values = {};
        if (window.seriesId) values.theme = [window.seriesId]; //set series filter (on series page seriesId is set)
        if (window.tagId) values.series = [window.tagId];
        if (window.filterPremiere) values.series = [10];
        if (!this.$filter) return values;

        const data = new FormData(this.$filter);
        for (let [key, value] of data) {
            if (!value) continue;
            if (key.indexOf('[]') !== -1) {
                key = key.replace('[]', '');
                if (typeof values[key] == 'undefined') {
                    values[key] = [value];
                } else {
                    values[key].push(value);
                }
            } else {
                values[key] = value;
            }
        }

        if (this.calendar) {
            const dates = this.calendar.selectedDates;
            if (dates) {
                values['dates'] = dates
            }
        }

        return values;
    }
}
